import React from 'react';
import PropTypes from 'prop-types';
import { getDestructuredText } from '../../../../general/js/utils';

function FormContactInfo({ contactDetails }) {
    return (
        <div className='form-checkbox-panel'>
            <h5 className='form-checkbox-panel__title'>
                {getDestructuredText(contactDetails.label, contactDetails.link)}
            </h5>
        </div>
    );
}

FormContactInfo.propTypes = {
    contactDetails: PropTypes.object.isRequired
};

export default FormContactInfo;
